import PageHeader from "@/components/PageHeader";
import BulkDeleteAppointments from "@/components/BulkDeleteAppointments";
import AutoPurgeStatusCard from "@/components/AutoPurgeStatusCard";
import GCalRecoveryCard from "@/components/GCalRecoveryCard";

export default function PuliziaCalendarioPage() {
  return (
    <div className="min-h-screen bg-gray-100 bg-grid-light pb-12 pt-[calc(7px+3.5rem+13px)]">
      <div className="max-w-6xl mx-auto px-4">
        <PageHeader
          title="Pulizia Calendario"
          subtitle="Eliminazione massiva degli appuntamenti del Calendario Generale"
        />

        <div className="-mt-8 relative z-10 space-y-4">
          <AutoPurgeStatusCard />
          <BulkDeleteAppointments />
          <GCalRecoveryCard />
        </div>
      </div>
    </div>
  );
}
